// hooks/useToast.ts
import { useSnackbar } from 'notistack';

export const useToast = () => {
  const { enqueueSnackbar } = useSnackbar();

  const showSuccess = (message: string) => {
    enqueueSnackbar(message, {
      variant: 'success',
      autoHideDuration: 2000
    });
  };

  const showError = (message: string) => {
    enqueueSnackbar(message, {
      variant: 'error',
      autoHideDuration: 3000
    });
  };

  const showInfo = (message: string) => {
    enqueueSnackbar(message, {
      variant: 'info',
      autoHideDuration: 2000
    });
  };

  const showWarning = (message: string) => {
    enqueueSnackbar(message, {
      variant: 'warning',
      autoHideDuration: 3000
    });
  };

//   const queueMessage =  enqueueSnackbar('Success message', {
//     variant: 'success',
//     autoHideDuration: 3000,
//     anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
//   });
  

  return { showSuccess, showError, showInfo, showWarning };
};
